export enum UserRole {
  ADMIN = 'admin',
  ORGANIZER = 'organizer',
  CUSTOMER = 'customer'
}

type RawUser = {
  id: string;
  email: string;
  name: string;
  phone: string;
  cpf_or_rg: string;
  birth_date: string;
  role: UserRole;
  created_at: string;
};

export function mapUser(user: RawUser, settings?: object) {
  return {
    id: user.id,
    email: user.email,
    name: user.name,
    phone: user.phone,
    cpf_or_rg: user.cpf_or_rg,
    birth_date: user.birth_date,
    role: user.role,
    created_at: user.created_at,
    from: 'jwt',
    data: {
      displayName: user.name,
      email: user.email,
      photoURL: 'https://e7.pngegg.com/pngimages/84/165/png-clipart-united-states-avatar-organization-information-user-avatar-service-computer-wallpaper.png',
      settings,
      shortcuts: ['calendar', 'mail', 'contacts', 'todo'],
    },
    isAdmin: user.role === UserRole.ADMIN,
    isOrganizer: user.role === UserRole.ORGANIZER,
    isCustomer: user.role === UserRole.CUSTOMER,
  };
}